/**
 * APIError Custom Class which creates custom error instances based on status code
 */
export default class APIError {
  public statusCode;
  public errorCode;
  private apiErrorMessage;

  constructor({
    statusCode,
    apiErrorMessage,
    errorCode,
  }: {
    statusCode: number;
    apiErrorMessage: string | undefined;
    errorCode?: number;
  }) {
    this.statusCode = statusCode;
    this.apiErrorMessage = apiErrorMessage;
    this.errorCode = errorCode;
  }
  get message() {
    switch (this.statusCode) {
      case 400:
        return this.apiErrorMessage;
      case 401:
        return this.apiErrorMessage;
      case 403:
        return this.apiErrorMessage;
      case 404:
        return "Something went wrong please contact varaha admin";

      default:
        return "Something went wrong please contact varaha admin";
    }
  }
}
